var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const DIRECTION_TRANSFORM = {
    up: undefined,
    right: 'rotate(90 16 16)',
    down: 'rotate(180 16 16)',
    left: 'rotate(270 16 16)',
};
const Arrow = (_a) => {
    var { direction, strokeWidth: strokeWidthProp } = _a, props = __rest(_a, ["direction", "strokeWidth"]);
    const iconProps = useIconProps(props);
    const computedStrokeWidth = useStrokeWidth(iconProps.width);
    const strokeWidth = strokeWidthProp !== null && strokeWidthProp !== void 0 ? strokeWidthProp : computedStrokeWidth;
    const transform = DIRECTION_TRANSFORM[direction];
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsxs("g", { transform: transform, children: [_jsx("path", { d: "M16 30.5L16 16L16 1.5", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", className: "arrow-tail", width: 32 }), _jsx("path", { d: "M26 11L16 1.18182L6 11", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round" })] }) })));
};
export default Arrow;
